import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsSdconfigRoute: InvariantJiraRoute = {
	name: 'global-settings-products-sdconfig',
	path: '/secure/admin/SDConfiguration.jspa',
};
